import { OrdersComponent } from './pages/orders/orders.component';
import { CanceledOrdersComponent } from './pages/orders/canceled-orders/canceled-orders.component';
import { SentOrdersComponent } from './pages/orders/sent-orders/sent-orders.component';
import { EditTemplateComponent } from './pages/templates/edit-template/edit-template.component';
import { MessagesComponent } from './pages/messages/messages.component';
import { UserConfigComponent } from './pages/user-config/user-config.component';
import { AdhocComponent } from './pages/adhoc/adhoc.component';
import { HelpComponent } from './pages/help/help.component';
import { CookiesPolicyComponent } from './pages/cookies-policy/cookies-policy.component';
import { AuthGuard } from './core/auth/auth.guard';
import { ObserverComponent } from './pages/observer/observer.component';
import { AupDetailsComponent } from './pages/observer/aup-details/aup-details.component';
import { RqaOrderComponent } from './pages/rqa-order/rqa-order.component';
import { TemplatesComponent } from './pages/templates/templates.component';
import { Routes } from '@angular/router';
import { AupMapResolver } from './map/aup-map/aup-map.resolver';
import { RqaMapResolver } from './map/rqa-map/rqa-map.resolver';
import { AccessDeniedComponent } from './pages/access-denied/access-denied.component';
import { Roles } from './core/auth/roles.enum';

export const routes: Routes = [
  {
    path: '',
    component: RqaOrderComponent,
    canActivate: [AuthGuard],
    data: { roles: [Roles.WEBRQA_USER, Roles.WEBRQA_DRAW] },
    pathMatch: 'full',
    resolve: { layers: RqaMapResolver }
  },
  {
    path: 'rqa',
    component: RqaOrderComponent,
    canActivate: [AuthGuard],
    data: { roles: [Roles.WEBRQA_USER, Roles.WEBRQA_DRAW] },
    pathMatch: 'full'
  },
  {
    path: 'observer',
    component: ObserverComponent,
    canActivate: [AuthGuard],
    data: { roles: [Roles.WEBRQA_USER, Roles.WEBRQA_DRAW, Roles.WEBRQA_OBSERVER, Roles.WEBRQA_VIEWER] }
  },
  {
    path: 'observer/aup/:date',
    component: AupDetailsComponent,
    canActivate: [AuthGuard],
    data: { roles: [Roles.WEBRQA_USER, Roles.WEBRQA_DRAW, Roles.WEBRQA_OBSERVER, Roles.WEBRQA_VIEWER] },
    resolve: { layers: AupMapResolver }
  },
  {
    path: 'observer/uup/:date',
    component: AupDetailsComponent,
    canActivate: [AuthGuard],
    data: { roles: [Roles.WEBRQA_USER, Roles.WEBRQA_DRAW, Roles.WEBRQA_OBSERVER, Roles.WEBRQA_VIEWER] },
    resolve: { layers: AupMapResolver }
  },
  {
    path: 'orders',
    component: OrdersComponent,
    canActivate: [AuthGuard],
    data: { roles: [Roles.WEBRQA_USER, Roles.WEBRQA_DRAW, Roles.WEBRQA_VIEWER] },
    resolve: { layers: RqaMapResolver },
    children: [
      {
        path: '',
        redirectTo: 'sent',
        pathMatch: 'full'
      },
      {
        path: 'sent',
        component: SentOrdersComponent
      },
      {
        path: 'canceled',
        component: CanceledOrdersComponent
      }
    ]
  },
  {
    path: 'templates',
    component: TemplatesComponent,
    canActivate: [AuthGuard],
    data: { roles: [Roles.WEBRQA_USER, Roles.WEBRQA_DRAW] },
    resolve: { layers: RqaMapResolver }
  },
  {
    path: 'templates/edit/:id',
    component: EditTemplateComponent,
    canActivate: [AuthGuard],
    data: { roles: [Roles.WEBRQA_USER, Roles.WEBRQA_DRAW] }
  },
  {
    path: 'adhoc',
    component: AdhocComponent,
    canActivate: [AuthGuard],
    data: { roles: [Roles.WEBRQA_DRAW] },
    resolve: { layers: RqaMapResolver }
  },
  {
    path: 'messages',
    component: MessagesComponent,
    canActivate: [AuthGuard],
    data: { roles: [Roles.WEBRQA_USER, Roles.WEBRQA_DRAW, Roles.WEBRQA_VIEWER] }
  },
  {
    path: 'user-config',
    component: UserConfigComponent,
    canActivate: [AuthGuard],
    data: { roles: [Roles.WEBRQA_USER, Roles.WEBRQA_DRAW, Roles.WEBRQA_VIEWER, Roles.WEBRQA_OBSERVER] }
  },
  {
    path: 'help',
    component: HelpComponent,
    canActivate: [AuthGuard],
    data: { roles: [Roles.WEBRQA_USER, Roles.WEBRQA_DRAW, Roles.WEBRQA_VIEWER, Roles.WEBRQA_OBSERVER] }
  },
  {
    path: 'privacy-policy',
    component: CookiesPolicyComponent,
    canActivate: [AuthGuard],
    data: { roles: [Roles.WEBRQA_USER, Roles.WEBRQA_DRAW, Roles.WEBRQA_VIEWER, Roles.WEBRQA_OBSERVER] }
  },
  {
    path: 'access-denied',
    component: AccessDeniedComponent
  },
  { path: '**', redirectTo: '' }
];
